import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the whole app.
 *
 * Defaults tuned for an internal app:
 *   - Long-ish staleTime keeps the UI snappy and reduces background refetches.
 *   - Retries only happen on truly transient failures (network errors, 5xx).
 *     A 401/403/404 should fail fast and surface to the user, not retry.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,            // 30s — fine for ticket lists; mutations bust caches manually
      gcTime: 5 * 60_000,
      retry: (failureCount, error: unknown) => {
        const status = (error as { status?: number })?.status;
        if (status && status < 500 && status !== 408 && status !== 429) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false
    },
    mutations: {
      retry: false
    }
  }
});
